import useSEO from "@/hooks/useSEO";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Impressum() {
  useSEO({
    title: "Impressum · Niko's Grill Bochum",
    description: "Impressum von Niko's Grill, Höntroper Str. 2, 44869 Bochum.",
    path: "/impressum",
  });

  return (
    <main className="bg-[var(--niko-cream)]" data-testid="impressum-page">
      <Navbar />
      <section className="pt-40 pb-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[var(--niko-charcoal)]/65 hover:text-[var(--niko-blue)] transition-colors mb-10"
            data-testid="back-home"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>

          <p className="divider-leaf max-w-[150px] mb-6">Rechtliches</p>
          <h1 className="font-display text-5xl md:text-6xl text-[var(--niko-charcoal)] leading-[1.05]">
            Impressum
          </h1>

          <div className="mt-12 space-y-10 text-[var(--niko-charcoal)]/85 leading-[1.8]">
            <Block title="Angaben gemäß § 5 TMG">
              Inhaber: Anastasios Denesakis
              <br />
              Niko's Grill
              <br />
              Höntroper Str. 2
              <br />
              44869 Bochum
            </Block>

            <Block title="Kontakt">
              Telefon: <a className="underline decoration-[var(--niko-gold)]" href="tel:+492327995454">+49 2327 995454</a>
              <br />
              E-Mail:{" "}
              <a className="underline decoration-[var(--niko-gold)]" href="mailto:NikosGrillBochum@gmail.com">
                NikosGrillBochum@gmail.com
              </a>
            </Block>

            <Block title="Steuernummer">
              350 5042 3320
              <br />
              <span className="text-sm text-[var(--niko-charcoal)]/55">
                (Lokale Steuernummer gemäß Impressum)
              </span>
            </Block>

            <Block title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
              Anastasios Denesakis
              <br />
              Anschrift wie oben
            </Block>

            <Block title="Haftungsausschluss">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
              Haftung für die Inhalte externer Links. Für den Inhalt der
              verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </Block>

            <Block title="Urheberrecht">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              dieser Website unterliegen dem deutschen Urheberrecht.
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </Block>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl text-[var(--niko-blue)] mb-3">
        {title}
      </h2>
      <p className="text-base">{children}</p>
    </div>
  );
}
